import { render, staticRenderFns } from "./TechnologyButtons.vue?vue&type=template&id=89a2b476&scoped=true&"
import script from "./TechnologyButtons.vue?vue&type=script&lang=js&"
export * from "./TechnologyButtons.vue?vue&type=script&lang=js&"
import style0 from "./TechnologyButtons.vue?vue&type=style&index=0&id=89a2b476&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a2b476",
  null
  
)

export default component.exports